/* eslint-disable global-require */
import React, { useContext } from 'react'
import { useIntl } from 'react-intl'

// types
import { IconRegularChevronRight } from '@notino/react-styleguide'
import { ReservationResponse } from '../../../../types/types'

// utils
import { PAGE_LINKS } from '../../../../utils/helper'
import { AppContext } from '../../../../utils/appProvider'

// styles
import * as SC from './SalonInfoStyles'

// hooks
import useMessages from '../../../../hooks/useMessages'

type Props = {
	salonData: NonNullable<ReservationResponse['reservation']>['calendarEvent']['salon']
}

const SalonInfo = (props: Props) => {
	const { messages } = useMessages()
	const { locale } = useIntl()
	const { assetsPath } = useContext(AppContext)

	const { salonData } = props

	const salonImageSrc = salonData.images.find((image) => image.isCover)?.resizedImages.medium || salonData.images[0]?.resizedImages.medium
	const salonImage = salonImageSrc || `${assetsPath}/${require('../../../../assets/images/basic-salon-placeholder.jpg')}`
	const salonImageWebP = salonImageSrc ? undefined : `${assetsPath}/${require('../../../../assets/images/basic-salon-placeholder.webp')}`

	return (
		<SC.SalonInfo
			$backgroundImage={salonImage}
			$backgroundImageWebP={salonImageWebP}
			href={PAGE_LINKS['/salons/:salonSlug'](locale, salonData.seoSlugName)}
		>
			{salonData.logo && (
				<SC.SalonLogoWrapper>
					<img src={salonData.logo.resizedImages.small} alt={messages['Salon logo']} />
				</SC.SalonLogoWrapper>
			)}
			<SC.BottomArea>
				<SC.BottomAreaLeft>
					{salonData.name && <SC.SalonName>{salonData.name}</SC.SalonName>}
					{salonData.formattedAddress && <SC.SalonAddress>{salonData.formattedAddress}</SC.SalonAddress>}
				</SC.BottomAreaLeft>
				<IconRegularChevronRight width={'1.5rem'} height={'1.5rem'} color={'icon.inverse'} />
			</SC.BottomArea>
		</SC.SalonInfo>
	)
}

export default SalonInfo
